'use client';

import { Box, Divider, Grid, Title } from '@mantine/core';
import { useMediaQuery } from '@mantine/hooks';

import { FancyTableOfContents } from '../FancyTableOfContents/FancyTableOfContents';

interface FancyTOCWrapperProps {
  rightColumn: React.ReactNode;
  showTitle?: boolean;
}

// Make sure the react componenet you want to render in the right column
// is a Grid.Col with a span of 8 and an id of "content"
const FancyTOCWrapper: React.FC<FancyTOCWrapperProps> = ({
  rightColumn,
  showTitle = true,
}) => {
  const isMobile = useMediaQuery('(max-width: 768px)');

  return (
    <Grid>
      {/* Right Column - Content */}
      {/* Only show the table of contents on desktop */}
      {!isMobile && (
        <Grid.Col
          span={4}
          pr="0"
        >
          <Box
            style={{
              position: 'sticky',
              top: '20px',
              paddingRight: '24px',
            }}
          >
            <Box
              id="toc-highlight"
              style={{
                position: 'absolute',
                left: 'calc(100% + 1px)',
                width: '2px',
                height: '20px',
                backgroundColor: 'var(--mantine-color-primary-6)',
                borderRadius: '1px',
                transition: 'top 0.2s ease',
              }}
            />
            {showTitle && (
              <Title
                order={3}
                mb="md"
              >
                Table of Contents
              </Title>
            )}
            <FancyTableOfContents showTitle={showTitle} />
          </Box>

          <Divider
            orientation="vertical"
            style={{
              height: '100%',
            }}
          />
        </Grid.Col>
      )}

      {/* Right Column - Content */}
      {rightColumn}
    </Grid>
  );
};

export { FancyTOCWrapper };
